"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAllowCapture = exports.isParent = exports.isBrowser = exports.removeFromArray = void 0;
function removeFromArray(arr, obj) {
    var index = arr.indexOf(obj);
    if (index !== -1) {
        arr.splice(index, 1);
    }
}
exports.removeFromArray = removeFromArray;
exports.isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
var is_nil_1 = require("@antv/util/lib/is-nil");
Object.defineProperty(exports, "isNil", { enumerable: true, get: function () { return is_nil_1.default; } });
var is_function_1 = require("@antv/util/lib/is-function");
Object.defineProperty(exports, "isFunction", { enumerable: true, get: function () { return is_function_1.default; } });
var is_string_1 = require("@antv/util/lib/is-string");
Object.defineProperty(exports, "isString", { enumerable: true, get: function () { return is_string_1.default; } });
var is_object_1 = require("@antv/util/lib/is-object");
Object.defineProperty(exports, "isObject", { enumerable: true, get: function () { return is_object_1.default; } });
var is_array_1 = require("@antv/util/lib/is-array");
Object.defineProperty(exports, "isArray", { enumerable: true, get: function () { return is_array_1.default; } });
var mix_1 = require("@antv/util/lib/mix");
Object.defineProperty(exports, "mix", { enumerable: true, get: function () { return mix_1.default; } });
var each_1 = require("@antv/util/lib/each");
Object.defineProperty(exports, "each", { enumerable: true, get: function () { return each_1.default; } });
var upper_first_1 = require("@antv/util/lib/upper-first");
Object.defineProperty(exports, "upperFirst", { enumerable: true, get: function () { return upper_first_1.default; } });
// 是否元素的父容器
function isParent(container, shape) {
    // 所有 shape 都是 canvas 的子元素
    if (container.isCanvas()) {
        return true;
    }
    var parent = shape.getParent();
    var isParent = false;
    while (parent) {
        if (parent === container) {
            isParent = true;
            break;
        }
        parent = parent.getParent();
    }
    return isParent;
}
exports.isParent = isParent;
function isAllowCapture(element) {
    // @ts-ignore
    return element.cfg.visible && element.cfg.capture;
}
exports.isAllowCapture = isAllowCapture;
//# sourceMappingURL=util.js.map